module.exports = __webpack_public_path__ + "img/vk.5131ec5.png";